export const dataTypeConst = {
  AV: "AV",
  CV: "CV",
  TV: "TV",
};
